import React from 'react';
import { Redirect } from 'react-router';
import getCaretCoordinates from 'textarea-caret';
import TextareaAutosize from 'react-autosize-textarea';

import Post from '../components/Post';

import ImageController from './ImageController';

import '../styles/write.css';

export default class WriteController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collectionId: props.match.params.collectionId,
      postId: props.match.params.id,
      content: props.content,
      loading: props.match.params.id ? true : false,
      mode: props.mode || 'full',
      title: props.title,
      day: props.day,
      showControls: true
    };
    this.scrollToCaret = this._scrollToCaret.bind(this);
    this.addImage = this._addImage.bind(this);
    this.inputRef = React.createRef();
  }

  componentWillMount() {
    const that = this;
    if (this.state.postId) {
      this.loadPost();
    }
    window.onmousemove = (e) => that.setState({showControls: true});
  }

  loadPost() {
    const that = this;
    fetch('/api/post/' + this.state.postId, {credentials: 'same-origin', method: 'GET'})
      .then((res) => {
        res.json().then((post) => {
          that.setState({content: post.content, loading: false, title: post.title});
        });
      });
  }

  save() {
    const that = this;
    const url = (this.state.postId) ? `/api/write/${this.state.postId}` : '/api/write';
    const options = {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'POST',
      body: JSON.stringify({
        collectionId: this.state.collectionId,
        content: this.state.content,
        title: this.state.title
      })
    };
    fetch(url, options).then((res) => {
      if (res.status === 201) {
        res.json().then((post) => that.setState({postId: post.id, redirect: true}));
      }
    });
  }

  setContent(content) {
    this.setState({content});
  }

  setTitle(title) {
    this.setState({title});
  }

  _scrollToCaret(e) {
    const position = getCaretCoordinates(
      this.inputRef.current.textarea,
      this.inputRef.current.textarea.selectionEnd);
    const offsetTop = this.inputRef.current.textarea.offsetTop;
    window.scrollTo(0, (position.top + offsetTop) - parseInt(window.innerHeight / 2, 10));
  }

  _addImage(image) {
    this.setContent(`${this.state.content || ''} ![Image](/image/${image.id})`);
  }

  writePanel() {
    return [
      <input
        type='text'
        className='title'
        name='Title'
        key='title-field'
        onChange={(e) => this.setTitle(e.target.value)}
        placeholder='Title'
        value={this.state.title} />,
      <TextareaAutosize
        key='content-field'
        onChange={(e) => this.setContent(e.target.value)}
        onClick={this.scrollToCaret}
        onKeyUp={this.scrollToCaret}
        onKeyPress={(e) => this.hideControls(e) }
        ref={this.inputRef}
        value={this.state.content} />]
  }

  previewPanel() {
    return <Post content={this.state.content} title={this.state.title} />;
  }

  getPanels() {
    if (this.state.mode === 'full') {
      return <div className='col-md-6 col-md-offset-3'>{this.writePanel()}</div>;
    } else if (this.state.mode === 'live') {
      return [
        <div className='col-md-6'>{this.writePanel()}</div>,
        <div className='col-md-6'>{this.previewPanel()}</div>
      ];
    } else {
      return <div className='col-md-6 col-md-offset-3'>{this.previewPanel()}</div>;
    }
  }

  setMode(mode) {
    this.setState({mode});
  }

  fullscreen() {
    const el = document.documentElement;
    const rfs = el.requestFullscreen
        || el.webkitRequestFullScreen
        || el.mozRequestFullScreen
        || el.msRequestFullscreen;
    rfs.call(el);
  }

  hideControls(e) {
    if (this.state.showControls) {
      this.setState({showControls: false});
    }
  }

  getControls() {
    return this.state.showControls ? (<div className='write-controls'>
      <div className='container-fluid'>
        <div className='col-md-6 col-md-offset-3'>
          <ul className='preview-control'>
            <li onClick={(e) => this.setMode('full')}>
              <span className='glyphicon glyphicon-edit'/>
            </li>
            <li onClick={(e) => this.setMode('preview')}>
              <span className='glyphicon glyphicon-eye-open'/>
            </li>
            <li onClick={(e) => this.fullscreen()}>
              <span className='glyphicon glyphicon-resize-full'/>
            </li>
            <li>
              <button onClick={(e) => this.save()}>
                <span className='glyphicon glyphicon-floppy-disk'/>
              </button>
            </li>
            <li>
              <ImageController onUpload={this.addImage}>
                <span className='glyphicon glyphicon-picture' />
              </ImageController>
            </li>
          </ul>
        </div>
      </div>
    </div>) : '';
  }

  render() {
    if (this.state.loading) {
      return <div>Loading post for editing..</div>;
    }

    if (this.state.redirect) {
      return <Redirect to={`/write/${this.state.postId}`}/>;
    }

    return (<div className='write'>
      <div className='container-fluid'>
        {this.getPanels()}
      </div>
      {this.getControls()}
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/WriteController.js